import * as React from 'react'

export const AmpLayout = (props) => {
  const { children } = props
  return (
    <React.Fragment>
      <amp-layout {...props} key="layout">
        {children}
      </amp-layout>
    </React.Fragment>
  )
}

export default AmpLayout
